import React, {Component} from 'react'
import { Table } from 'components/UI'
import {browserHistory} from 'react-router'
import {confirm} from 'util/confirm'
import {alert} from 'util/alert'
import TeacherListTd from './TeacherListTd'
import StudentAmountTd from './StudentAmountTd'
import StudentInfoFloat from 'template/Floats/StudentInfoFloat';
import AddLesson from 'template/Docks/AddLesson'
import LessonEditTimeModal from 'template/Modals/LessonEditTime'
import LessonEditColorModal from 'template/Modals/LessonEditColor'
import LessonEditTeacherModal from 'template/Modals/LessonEditTeacher'
import LessonEditStudentModal from 'template/Modals/LessonEditStudent'
import LessonEditClassroomModal from 'template/Modals/LessonEditClassroom'
import Loading from 'components/UI/Loading';
import __R from 'containers/__R';
import deleteMultiLesson from 'controllers/lesson/deleteMultiLesson'
import {fetchClassLesson} from '../ducks'
import getLessonStudentList from 'controllers/lesson/getLessonStudentList';

const CONTROLLER_WIDTH = '150px'

class LessonTable extends Component {
  constructor(props){
    super(props)

    this.state = {
      selectedLesson: {
        selected: []
      },
      float: {},
      deleting: false,
      student_list: [],
      openFloatModal: false,
      fetchingStudentList: false,
      floatTarget: null
    }

    this.openFloat = this.openFloat.bind(this)
    this.closeFloat = this.closeFloat.bind(this)
    this.addLesson = this.addLesson.bind(this)
  }
  openFloat(lesson_id, lesson_number){
    return (e) => {
      e.preventDefault();
      this.setState({
        floatTarget: e.currentTarget,
        lesson_number,
        fetchingStudentList: true,
        openFloatModal: true
      })
      getLessonStudentList(lesson_id)
      .then(res=>{
        this.setState({student_list: res.student_list, fetchingStudentList: false}, ()=>{
          this.forceUpdate()
        })
      })
    }
  }

  closeFloat(){
    this.setState({student_list:[], lesson_number:0, openFloatModal: false, floatTarget: null})
  }

  addLesson() {
    const {tableData, dispatch, state, pagination} = this.props
    const {classID} = tableData

    AddLesson({chooseClass: false, classDetail: tableData })
      .then((data) => {
        dispatch(fetchClassLesson(classID, {
          amount_per_page: pagination.itemsCountPerPage,
          current_page_number: pagination.activePage,
          after_today: state === 'current'? 1: 0
        }))
      });
  }

  render(){
    let {tableData, dispatch, settings, fetching, pagination, usePagination, onPageChange, onItemsCountPerPageChange} = this.props;
    let state = this.props.state === 'current'? 1: 0;

    if(!tableData){
      return ( <div/> )
    }

    const fields = [
    {
      name: 'number',
      title: __('Lesson', 'classdetail'),
      getTdContent: ({ trIndex, trData })=>{
        const { calendar_color, lesson_number } = trData;

        return (
          <span>{ __('Lesson', 'classdetail') +' ' + lesson_number}</span>
        );
      },
      getTdProps: ({trData}) => {
        const { lesson_status } = trData;
        return {
          style: {width: "10%", opacity: lesson_status === 1 ? 0.35 : 1 }
        }
      }
    },
    {
      name: 'date',
      title: __('Lesson Date', 'classdetail'),
      getTdContent: ({ trData: lessonInfo })=>{
        return lessonInfo.lesson_start_time.slice(0,11)
      },
      getTdProps: ({trData}) => {
        const { lesson_status } = trData;
        return {
          style: {width: "12%", opacity: lesson_status === 1 ? 0.35 : 1 }
        }
      }
    },
    {
      name: 'lesson_time',
      title: __('Lesson Time', 'classdetail'),
      getTdContent: ({ trData: lessonInfo })=>{
        return lessonInfo.lesson_start_time.slice(11,16) + " – " + lessonInfo.lesson_end_time.slice(11,16)
      },
      getTdProps: ({trData}) => {
        const { lesson_status } = trData;
        return {
          style: {width: "12%", opacity: lesson_status === 1 ? 0.35 : 1 }
        }
      }
    },
    {
      name: 'teacher_list',
      title: __('Teacher', 'teacher'),
      getTdContent: ({ trData: lessonInfo })=>{
        return <TeacherListTd lessonInfo={lessonInfo} {...this.props} />
      },
      getTdProps: ({trData}) => {
        const { lesson_status } = trData;
        return {
          style: {width: "15%", opacity: lesson_status === 1 ? 0.35 : 1 }
        }
      },
    },
    {
      name: 'classroom_name',
      title: __('Classroom', 'classdetail'),
      getTdContent: ({ trData: lessonInfo })=>{
        return lessonInfo.classroom_name ? lessonInfo.classroom_name : ''
      },
      getTdProps: ({trData}) => {
        const { lesson_status } = trData;
        return {
          style: {width: "15%", opacity: lesson_status === 1 ? 0.35 : 1 }
        }
      }
    },
    {
      name: 'student_amount',
      title: __('Student Counts', 'classdetail'),
      getTdContent: ({ trData: lessonInfo })=>{
        return <StudentAmountTd lessonInfo={lessonInfo} openFloat={this.openFloat} {...this.props} />
      },
      getTdProps: ({ trData}) => {
        const { lesson_status } = trData;
        return {
          style: {width: "10%", opacity: lesson_status === 1 ? 0.35 : 1 }
        }
      }
    }]

    const {student_list, openFloatModal, floatTarget, lesson_number, selectedLesson, deleting, fetchingStudentList} = this.state;
    const {selected} = selectedLesson
    const {cState, classID, cType} = tableData
    const schoolId = localStorage.getItem('schoolId')

    let lesson_id_list = []
    selected.map((lesson) => {
      lesson_id_list.push(lesson.lesson_id)
    })

    if(deleting){
      return(
        <Loading />
      )
    }
    return(
      <div>
        <Table
          data={tableData.lessonList}
          fields={fields}
          className='teacher-table'
          settingThTitle={__('Settings', 'class')}
          settingWidth={CONTROLLER_WIDTH}
          settings={settings}
          useMultiSelection={false}
          oneSettingPerRow={false}
          dropdownGuideWidth={160}
          dropdownGuideHeight={228}
          usePagination={usePagination}
          pagination={pagination}
          onPageChange={onPageChange}
          onItemsCountPerPageChange={onItemsCountPerPageChange}
          useMultiSelection={true}
          fetching={fetching}
          onTrSelect={(selected) => {this.setState({selectedLesson: selected})}}
          getCheckboxTdProps={({ trData })=>{
            const { calendar_color, lesson_status } = trData;
            return {
              style: {borderLeft: '4.5px solid ' + calendar_color, opacity: lesson_status === 1 ? 0.35 : 1  }
            }
          }}
          getCheckboxDisabled={({ trData })=>{
            const { lesson_status } = trData;
            if (lesson_status === 1) {
              return true;
            } else {
              return false;
            }
          }}
          hasTopUtilSection={true}
          topUtilSection={
            <div>
            <__R can={cType == 0?'edit_lesson': 'edit_private_lesson'} by='disable'>
              <button className='btn btn-default' disabled={selected.length == 0 ? true : false} onClick={() => {
                LessonEditTimeModal({selected, classID, dispatch, pagination, state})
                .then(() => {this.setState({
                  selectedLesson: {
                    ...this.state.selectedLesson,
                    selected: []
                  }
                })})
              }}>
                {__('Reset Time','lessonTable')}
              </button>
            </__R>
            <__R can={cType == 0?'edit_lesson': 'edit_private_lesson'} by='disable'>
              <button className='btn btn-default' disabled={selected.length == 0  ? true : false} onClick={() => {
                LessonEditTeacherModal({schoolId, selectMultiple: true, lesson_id_list, classID, dispatch, pagination, state})
                .then(() => {this.setState({
                  selectedLesson: {
                    ...this.state.selectedLesson,
                    selected: []
                  }
                })})
              }}>
                {__('Reset Teacher','lessonTable')}
              </button>
            </__R>
            <__R can={cType == 0?'edit_lesson': 'edit_private_lesson'} by='disable'>
              <button className='btn btn-default' disabled={selected.length == 0  ? true : false} onClick={() => {
                LessonEditClassroomModal({schoolId, lesson_id_list, classID, dispatch, pagination, state})
                .then(() => {
                  this.setState({
                    selectedLesson: {
                      ...this.state.selectedLesson,
                      selected: []
                    }
                  })
                })
              }}>
                {__('Reset Classroom','lessonTable')}
              </button>
            </__R>
              { cType == 0 &&
                <__R can='edit_lesson' by='disable'>
                  <button className='btn btn-default' disabled={selected.length == 0  ? true : false} onClick={() => {
                    LessonEditStudentModal({schoolId, selectMultiple: true, lesson_id_list, classID, dispatch, pagination, state})
                    .then(() => {
                      this.setState({
                        selectedLesson: {
                          ...this.state.selectedLesson,
                          selected: []
                        }
                      })
                    })
                  }}>
                    {__('Reset Students','lessonTable')}
                  </button>
                </__R>
              }
              <__R can={cType == 0?'edit_lesson': 'edit_private_lesson'} by='disable'>
                <button
                  className='btn btn-default'
                  disabled={selected.length == 0  ? true : false}
                  onClick={() => {
                    LessonEditColorModal({classID, lesson_id_list, dispatch, pagination, state})
                    .then(() => {
                      this.setState({
                        selectedLesson: {
                          ...this.state.selectedLesson,
                          selected: []
                        }
                      })
                    })
                }}>
                  {__('Reset Color','lessonTable')}
                </button>
              </__R>
              <__R can={cType == 0?'edit_lesson': 'edit_private_lesson'} by='disable'>
                <button className='btn btn-default' disabled={selected.length == 0  ? true : false} onClick={() => {
                  confirm(__('Deleted lessons are unrecoverable, proceed to delete?', 'lessonTable'), __('Delete Lessons','lessonTable'))
                  .then(() => {
                    this.setState({deleting: true})
                    deleteMultiLesson({lesson_id_list})
                    .then((res) => {
                      this.setState({
                        selectedLesson: {
                          ...this.state.selectedLesson,
                          selected: []
                        },
                        deleting: false
                      })
                      if(res.result == 'success'){
                        dispatch(fetchClassLesson(classID,{
                          amount_per_page: pagination.itemsCountPerPage,
                          current_page_number: pagination.activePage,
                          after_today: state
                        }))
                      }
                    })
                  })
                }}>
                  {__('Delete Lessons','lessonTable')}
                </button>
              </__R>
              <__R can={cType == 0?'create_lesson': 'create_private_lesson'} by='disable'>
                <button className='btn btn-primary pull-right' onClick={this.addLesson} disabled={cState == 0 ? true : false} >
                  {__('Add Lesson', 'class')}
                </button>
              </__R>
            </div>
          }
        />
        <StudentInfoFloat
          studentInfo={student_list}
          lessonNumber={lesson_number}
          show={openFloatModal}
          target={floatTarget}
          onCloseFloat={this.closeFloat}
          isLoading={fetchingStudentList}
        />
      </div>
    )
  }
}

export default (LessonTable)



// WEBPACK FOOTER //
// ./src/containers/pages/ClassDetail/LessonTable/index.js